var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdadCorporalImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_13032",
    "data-name": "Group 13032",
    xmlns: "http://www.w3.org/2000/svg",
    width: 23.787,
    height: 23.794,
    viewBox: "0 0 23.787 23.794",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_7345",
    "data-name": "Path 7345",
    d: "M5454.331,1989.545h-1.394a1.271,1.271,0,0,0-.179-.038,11.315,11.315,0,0,1-5.189-1.637,11.741,11.741,0,0,1-5.644-8.173c-.083-.446-.124-.9-.186-1.349v-1.394c.015-.082.031-.164.043-.247.075-.512.117-1.031.227-1.535a11.888,11.888,0,1,1,20.555,10.319,11.677,11.677,0,0,1-6.88,3.87C5455.235,1989.44,5454.781,1989.484,5454.331,1989.545Zm-.71-2.6a9.293,9.293,0,1,0-9.28-9.305A9.32,9.32,0,0,0,5453.621,1986.943Z",
    transform: "translate(-5441.738 -1965.752)",
    fill: "#394f65"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_7346",
    "data-name": "Path 7346",
    d: "M5649.215,2080.645c0,.782,0,1.564,0,2.346a.54.54,0,0,0,.173.426q1.617,1.6,3.222,3.216a1.007,1.007,0,0,1-1.225,1.6,2.029,2.029,0,0,1-.242-.216q-1.767-1.764-3.534-3.529a1.214,1.214,0,0,1-.4-.9c0-1.781,0-3.561.006-5.342a.98.98,0,0,1,.924-.984,1,1,0,0,1,1.049.767,1.627,1.627,0,0,1,.03.369C5649.217,2079.143,5649.215,2079.894,5649.215,2080.645Z",
    transform: "translate(-5636.294 -2071.33)",
    fill: "#394f65"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdadCorporalImage);
export default __webpack_public_path__ + "static/media/edad_corporal_image.26169ee519b85aa4704a9a7e0004ecd3.svg";
export { ForwardRef as ReactComponent };